import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
// import axios from 'axios'
import store from './store'

import VueElementLoading from 'vue-element-loading'
import PageLoader from './components/Common/pageLoader'
import ImageLoader from "./components/Common/imageLoader";

Vue.component('VueElementLoading', VueElementLoading)
Vue.component('PageLoader', PageLoader)
Vue.component("ImageLoader", ImageLoader);

Vue.config.productionTip = false

new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
}).$mount('#app')